import { useLocation, Navigate, Outlet } from "react-router-dom";
import Cookie from "js-cookie"
import { DataProvider } from "../hooks/CommonContext";
import { encryptData } from "Security/Crypto/Crypto";

const RequireAuth = () => {
  const location = useLocation();
  const authToken = Cookie.get("pToken");
  const queryParams = new URLSearchParams(window.location.search);
  const jobID = queryParams.get("job_id");

  if (jobID) {
    if (window.location.pathname === "/professional/recommended_jobs") {
      const recommended_job_ID = queryParams.get("job_id");
      if (recommended_job_ID) { 
        if (isFinite(jobID)) {
          Cookie.set("recommended_job_id", encryptData(recommended_job_ID));
        } else {
          Cookie.set("recommended_job_id", recommended_job_ID);
        }
      } else {
        if (jobID) {
          if (isFinite(jobID)) {
            Cookie.set("job_id", encryptData(jobID));
          } else {
            Cookie.set("job_id", jobID);
          }
        }
      }
    } else {
      if (jobID) {
        if (isFinite(jobID)) {
          Cookie.set("job_id", encryptData(jobID));
        } else {
          Cookie.set("job_id", jobID);
        }
      }
    }
    
    var uri = window.location.toString();
    if (uri.indexOf("?") > 0) {
      var clean_uri = uri.substring(0, uri.indexOf("?"));
      window.history.replaceState({}, document.title, clean_uri);
    }
  }



  return authToken ? (
    <DataProvider>
      <Outlet />
    </DataProvider>
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default RequireAuth;
